import React, {useState, useEffect} from 'react';
import './css/App.css';
import './css/bootstrap.min.css';
import bootstrap from 'bootstrap';
const axios = require('axios').default;

class AlertWindow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {

    return(
      <div>
        <div className='pop-up alert-window' onClick={this.props.close}></div>
        <div className="container pop-up-window alert-window">
            <div className="row">
                <div className="col-12 container p-4">
                  <h3>{this.props.title}</h3>
                  <p className='text-center'>{this.props.message}</p>
                </div>
            </div>
        </div>
      </div>
    )
  }
}

export default AlertWindow;